
import React, { useState } from 'react';
import { Plus, Globe } from 'lucide-react';
import { Card, CardContent, CardDescription, CardHeader, CardTitle } from '@/components/ui/card';
import { Button } from '@/components/ui/button';
import { useRegions } from '@/hooks/useRegions';
import { Region, RegionFormData } from '@/types/regions';
import RegionFormDialog from './RegionFormDialog';
import RegionsTable from './RegionsTable';

const RegionsManagement = () => {
  const { regions, isLoading, createRegion, updateRegion, deleteRegion } = useRegions();
  const [dialogOpen, setDialogOpen] = useState(false);
  const [editingRegion, setEditingRegion] = useState<Region | null>(null);

  const handleAddRegion = () => {
    setEditingRegion(null);
    setDialogOpen(true);
  };

  const handleEditRegion = (region: Region) => {
    setEditingRegion(region);
    setDialogOpen(true);
  };

  const handleSubmit = async (data: RegionFormData) => {
    if (editingRegion) {
      await updateRegion(editingRegion.id, data);
    } else {
      await createRegion(data);
    }
  };

  const handleDeleteRegion = async (id: string) => {
    if (confirm('Are you sure you want to delete this region? This action cannot be undone.')) {
      await deleteRegion(id);
    }
  };

  return (
    <Card>
      <CardHeader>
        <div className="flex items-center justify-between">
          <div>
            <CardTitle className="flex items-center gap-2">
              <Globe size={20} />
              Regions Management
            </CardTitle>
            <CardDescription>
              Manage geographic regions to organize countries
            </CardDescription>
          </div>
          <Button onClick={handleAddRegion}>
            <Plus size={16} className="mr-2" />
            Add Region
          </Button>
        </div>
      </CardHeader>
      <CardContent>
        <RegionsTable
          regions={regions}
          loading={isLoading}
          onEdit={handleEditRegion}
          onDelete={handleDeleteRegion}
        />
        
        <RegionFormDialog
          open={dialogOpen}
          onOpenChange={setDialogOpen}
          editingRegion={editingRegion}
          onSubmit={handleSubmit}
        />
      </CardContent>
    </Card>
  );
};

export default RegionsManagement;
